import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const RequireAuth = ({ allowedRoles }) => {
    const user = useSelector((state) => state?.auth?.user);
    const location = useLocation();
    // console.log(user.privileges)
    // console.log("allowedRoles",allowedRoles)
    return (
        user?.privileges?.find((role) => {
            // console.log("role",role, allowedRoles)
            return allowedRoles?.find((allowRole) => allowRole === role.type && role.privilege)
        })
            ? <Outlet />
            : user
                ? <Navigate to="/unauthorized" state={{ from: location }} replace />
                : <Navigate to="/login" state={{ from: location }} replace />
    );
}

export default RequireAuth;